<template>
  <div id="comment">
    <div style="margin-bottom:10px" class="lv1Text">评价订单</div>
    <div style="font-size:12px;margin-bottom:20px">
      订单编号：
      <span class="lv3Text" style="margin-right:20px">{{data.orderCode}}</span>
      下单时间：
      <span
        class="lv3Text"
      >{{dayjs.unix(data.create_time).format('YYYY-MM-DD hh:mm:ss')}}</span>
    </div>
    <div class="box">
      <div v-for="(item,index) of products" :key="index">
        <el-row style="border-bottom:1px solid #ddd;">
          <el-col
            :span="6"
            style="border-right: 1px solid #ddd;text-align:center;padding: 165px 0;"
          >
            <div>
              <el-image
                style="width:160px;margin:0 auto;"
                :src="serve + item.images"
                fit="cover"
              ></el-image>
            </div>
          </el-col>
          <el-col :span="18" style="padding: 10px 50px;">
            <el-form label-position="right" label-width="120px">
              <el-form-item label="商品评分：">
                <el-rate v-model="form[index].rank" style="margin-top:10px"></el-rate>
              </el-form-item>
              <el-form-item label="印象标签：">
                <div class="clear">
                  <div
                    v-for="(item2,index2) in form[index].tags"
                    :key="index2"
                    class="clear-item tag"
                    @click="item2.status = !item2.status"
                    :class="item2.status==true?'active':''"
                  >{{item2.label}}</div>
                  <div class="clear-item tag">
                    <el-popover placement="top" width="200" v-model="visibles[index]">
                      <p>
                        <input
                          v-model="newString"
                          type="text"
                          placeholder="输入标签名称"
                          style="padding:5px;margin:10px;"
                        >
                      </p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="close(index)">取消</el-button>
                        <el-button type="primary" size="mini" @click="add(index)">确定</el-button>
                      </div>
                      <span slot="reference">
                        <i class="fas fa-edit"></i>自定义
                      </span>
                    </el-popover>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="填写评价：">
                <el-input v-model="form[index].content" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="上传图片：">
                <div style="margin-bottom:10px;">
                  <el-button type="primary" plain size="small" @click="openChooser(index)">
                    <i class="fas fa-cloud-upload-alt" style="margin-right:5px"></i>选择图片
                  </el-button>
                </div>
                <el-row>
                  <el-col :span="8" style="padding-right:15px">
                    <div>
                      <input
                        style="display:none"
                        type="file"
                        @change="processFile($event,index,0)"
                        :ref="'input-'+index+'-1'"
                      >
                    </div>
                    <div>
                      <img :src="form[index].srcArr[0]" class="p1">
                    </div>
                  </el-col>
                  <el-col :span="8" style="padding-right:15px">
                    <div>
                      <input
                        style="display:none"
                        type="file"
                        @change="processFile($event,index,1)"
                        :ref="'input-'+index+'-2'"
                      >
                    </div>
                    <div>
                      <img :src="form[index].srcArr[1]" class="p1">
                    </div>
                  </el-col>
                  <el-col :span="8" style="padding-right:15px">
                    <div>
                      <input
                        style="display:none"
                        type="file"
                        @change="processFile($event,index,2)"
                        :ref="'input-'+index+'-3'"
                      >
                    </div>
                    <div>
                      <img :src="form[index].srcArr[2]" class="p1">
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
    <div align="center" style="margin-top:20px;">
      <el-button style="width:150px" type="primary" @click="submit">提交评论</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      json: {},
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      newString: "",
      id: null,
      visibles: [],
      products: {},
      data: {},
      rate: [],
      form: [],
      tags: [
        "服务周到",
        "性能良好",
        "性价比高",
        "质量上乘",
        "快递给力",
        "值得拥有",
        "外观精致"
      ]
    };
  },
  methods: {
    submit() {
      for (var item of this.form) {
        for (var item2 of item.tags) {
          if (item2.status == true) {
            item.tag += ";" + item2.label;
          }
        }
      }
      for (var item of this.form) {
        delete item.srcArr;
        delete item.tags;
      }
      var form = new FormData();
      form.append("products", JSON.stringify(this.form));
      form.append("mobile", this.mobile);
      form.append("token", this.token);
      form.append("orderCode", this.data.orderCode);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      for (var pair of form.entries()) {
      }
      var that = this;
      this.axios
        .post(this.serve + "/personal/comment_orders", form, config)
        .then(function(res) {
          if (res.data.status == "success") {
            that.$router.push("/user/comment/after");
          }
        });
    },
    openChooser(index) {
      for (var i = 1; i < 4; i++) {
        if (this.form[index].srcArr[i - 1] == "") {
          var refs = "input-" + index + "-" + i;
          this.$refs[refs][0].click();
          return;
        }
      }
    },
    processFile(event, index, i) {
      var that = this;
      var imgFile = event.target.files[0];
      var reader = new FileReader();
      var form = new FormData();
      form.append("image", imgFile);
      form.append("mobile", this.mobile);
      form.append("token", this.token);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(this.serve + "/personal/save_comment_image",
          form,
          config
        )
        .then(function(res) {
          if ((res.data.status = "success")) {
            reader.readAsDataURL(imgFile);
            reader.onload = function(e) {
              var result = e.target.result;
              that.$set(that.form[index].srcArr, i, result);
              that.form[index].images += ";" + res.data.data;
            };
          }
        });
    },
    upload(prarm) {
      var imgObj = prarm.file;
      var reader = new FileReader();
      var form = new FormData();
      form.append("head", imgObj);
      form.append("mobile", this.mobile);
      form.append("token", this.token);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var that = this;
      this.axios
        .post(this.serve + "/personal/save_comment_image",
          form,
          config
        )
        .then(function(res) {
          if ((res.data.status = "success")) {
            reader.readAsDataURL(imgObj);
            reader.onload = function(e) {
              var result = e.target.result;
              that.imageUrl = result;
            };
            that.initData();
          }
        });
    },

    add(i) {
      this.$set(this.visibles, i, false);
      this.form[i].tags.push({ label: this.newString, status: false });
      this.newString = "";
    },
    close(i) {
      this.$set(this.visibles, i, false);
    },
    setTag(index, value) {
      if (this.actives[index] == true) {
        this.actives[index] = false;
      } else {
        this.actives[index] = true;
      }
    },
    initData() {
      this.axios
        .get(this.serve +"/personal/order_info", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.id
          }
        })
        .then(res => {
          this.data = res.data.data;
          this.products = JSON.parse(res.data.data.product_list);
          var i = 0;
          for (var item of this.products) {
            var arr = {
              product_id: item.p_id,
              content: "",
              rank: 0,
              tags: [],
              tag: "",
              images: "",
              srcArr: ["", "", ""]
            };
            this.form.push(arr);
            for (var item2 of this.tags) {
              this.form[i].tags.push({ label: item2, status: false });
            }
            this.visibles[i] = false;
            i++;
          }
        });
    }
  },
  created() {
    this.$store.state.user_location = "我的订单";
    this.$store.state.user_location2 = "评价晒单";
    this.$store.state.leftMenuIndex = 12;
    this.id = this.$route.query.id;
    this.initData();
  }
};
</script>
<style lang="scss">
#comment {
  .box {
    .p1 {
      display: block;
      width: 100%;
      height: auto;
    }
    background-color: #fff;
    border: 1px solid #ddd;
    .tag {
      border: 2px solid #ddd;
      padding: 5px 0;
      width: 90px;
      text-align: center;
      font-size: 13px;
      margin: 5px 10px;
      line-height: 1em;
      cursor: pointer;
    }
    .active {
      border: 2px solid #e2211c;
      color: #e2211c;
    }
  }
}
</style>